import React, { ReactNode } from 'react';
import { Stack, type StackProps, Typography } from '@mui/material';

type TextCellProps = { children?: ReactNode; tag?: ReactNode; minWidth?: number } & StackProps;

const TextCell = (props: TextCellProps) => {
  const { children, tag, minWidth = 168 } = props;

  return (
    <Stack
      className="TextCell-root"
      spacing={1.25}
      minWidth={minWidth}
      direction="row"
      alignItems="center"
      p={2}
      {...props}
    >
      <Typography variant="body2" className="TextCell-label">
        {children}
      </Typography>
      {tag}
    </Stack>
  );
};
export default TextCell;
